import { IIcon } from '@/types/generalTypes';

const GraduationCapIcon = ({ className }: IIcon) => {
  return (
    <svg
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      className={className}
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M14.6667 6.66663V10.6666M4 8.33329V10.6666C4 11.1971 4.42143 11.7058 5.17157 12.0808C5.92172 12.4559 6.93913 12.6666 8 12.6666C9.06087 12.6666 10.0783 12.4559 10.8284 12.0808C11.5786 11.7058 12 11.1971 12 10.6666V8.33329M14.2799 7.28137C14.3992 7.22872 14.5005 7.14221 14.5712 7.03257C14.6418 6.92293 14.6788 6.79496 14.6774 6.66453C14.6761 6.53409 14.6365 6.40692 14.5636 6.29876C14.4907 6.1906 14.3876 6.10621 14.2672 6.05603L8.5532 3.45337C8.37949 3.37413 8.19079 3.33313 7.99987 3.33313C7.80894 3.33313 7.62024 3.37413 7.44653 3.45337L1.7332 6.05337C1.61451 6.10535 1.51354 6.19079 1.44264 6.29924C1.37174 6.4077 1.33398 6.53446 1.33398 6.66403C1.33398 6.79361 1.37174 6.92037 1.44264 7.02882C1.51354 7.13728 1.61451 7.22272 1.7332 7.2747L7.44653 9.88003C7.62024 9.95927 7.80894 10.0003 7.99987 10.0003C8.19079 10.0003 8.37949 9.95927 8.5532 9.88003L14.2799 7.28137Z'
        stroke='currentColor'
        strokeWidth='1.2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};

export default GraduationCapIcon;
